import React from "react";

const CLIENTS = [
  "Ferrero",
  "Datalogic",
  "Babcock",
  "Enel X",
  "Radici Group",
  "TIM",
  "Ferroli",
  "EPSG",
  "D-Orbit",
  "Poltrona Frau",
  "Miroglio Group",
  "Pfizer",
  "Olivetti",
  "CNH Industrial",
  "Ariston Group",
  "Wesco Aircraft",
];

const HIGHLIGHTS = [
  {
    sector: "Industrial & Manufacturing",
    text: "Strategic plans, operational redesign and innovation pipelines for global industrial groups.",
  },
  {
    sector: "Energy & Utilities",
    text: "Market-entry frameworks, pretotyping and roadmap design for energy transition opportunities.",
  },
  {
    sector: "Consumer & Retail",
    text: "Brand-led transformation programmes that move from strategy deck to in-market reality.",
  },
  {
    sector: "Pharma & Healthcare",
    text: "Innovation academies and operating-model rewires for regulated, high-stakes environments.",
  },
];

export const Clients = () => {
  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="bg-brand-deeper text-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <span className="overline text-[#2EC4B6]">— Experiences we bring</span>
          </div>
          <div className="md:col-span-9">
            <h2
              className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]"
              data-testid="clients-heading"
            >
              Brands our people have shaped, scaled and stood beside.
            </h2>
            <p className="mt-6 max-w-2xl text-lg text-white/60 leading-relaxed">
              Sixteen+ years of senior consulting work, distilled. Every name
              below represents an organisation our consultants have personally
              led transformation, innovation or growth programmes for.
            </p>
          </div>
        </div>
      </div>

      {/* Editorial brand list — pure typography, no logos */}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ul
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-2 border-t border-white/10"
          data-testid="clients-list"
        >
          {CLIENTS.map((c, i) => (
            <li
              key={c}
              data-testid={`client-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className="group flex items-baseline gap-3 py-5 border-b border-white/10"
            >
              <span className="overline text-[#2EC4B6]/60 w-6 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-display text-2xl md:text-3xl tracking-tight text-white group-hover:text-[#2EC4B6] transition-colors duration-300">
                {c}
              </span>
            </li>
          ))}
        </ul>
      </div>

      {/* Sector highlights */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {HIGHLIGHTS.map((h, i) => (
            <div
              key={h.sector}
              data-testid={`sector-highlight-${i}`}
              className="bg-[#0A2427] p-8 group hover:bg-[#154247] transition-colors duration-500"
            >
              <div className="overline text-[#2EC4B6] mb-4">
                /{String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display text-xl md:text-2xl mb-3 tracking-tight text-white">
                {h.sector}
              </h3>
              <p className="text-sm text-white/60 leading-relaxed">{h.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
